<template>
  <div class="loginPage">
    <div class="login-leftBox">
      <img class="login-graphic" src="@/assets/image/LoginPage_Graphic.png"/>
    </div>
    <div class = "login-rightBox">
      <img src="@/assets/image/logo/fabulearn_h.png" />
      <p class="center">由香港中文大學團隊所開發，Fabulearn@schools是一個為翻轉教學量身訂造的教學資源平台。其設計重點在於不同學習階段的教學資源管理，包括課前、課上及課後。</p>
      <p class="center">利用平台，師生在使用、組織、甚至分享各種教學資源時變得更輕鬆容易。</p>
      <form class="" id="loginForm" @submit="login">
        <div class="">
          <div class="loginform-input">
            <div class="loginform-label">
              <label>電郵:</label>
            </div>
            <div class="loginform-field" >
              <input type="text" name="login_id">
            </div>
          </div>
          <div class="loginform-input">
            <div class="loginform-label">
              <label>密碼:</label>
            </div>
            <div class="loginform-field">
              <input type="password" name="password">
            </div>
          </div>
        </div>
        <input type="submit" name="" v-show="false">
        <div style="color: red;">{{error}}</div>
        <div class="loginform-btns">
          <div class="greenText" @click="forget_password">忘記密碼</div>
          <div class="greenText" @click="login" style="cursor: pointer;">登入</div>
        </div>
      </form>
      <div v-if="false" style= "padding: 2rem 0;">
        <div class="login-learnbtn">
          <img src="@/assets/image/LoginPage_icon.png" style="width: 60px">
          <span style="align-self: center; padding-left: 1rem; font-weight: 600; font-size: 1.2rem">學習大本營</span>
        </div>
      </div>
      <div class="center">
        <router-link to="/privacy-policy" target='_blank'><span class="login-policy">個人資料政策及免責聲明</span></router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine"; // Import the theme engine

  @include md-register-theme("default", (
    primary:#397f1f, // The accent or secondary color
  ));

  .greenText{
    color: #397f1f;
  }

  .loginPage{
    display: flex;
  }

  .login-leftBox{
    flex: 5;
    background-color: #397f1f;
  }
  .login-graphic{
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateY(-50%)translateX(-50%);
    max-height: 100vh;
    padding: 5rem 2rem;
  }
  .center{
    display: flex;
    justify-content: center;
  }
  .login-rightBox{
    flex: 0 0 400px;
    padding: 2rem 1.5rem;
  }

  #loginForm{
    background-color: #f5f5f5;
    border-radius: 1rem;
    padding: 2rem 3rem;
  }

  .loginform-btns{
    padding-top: 1.5rem;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }

  .loginform-input{
    padding: 0.5rem 0rem;
    display: flex;
    justify-content: space-between;
  }
  .login-learnbtn{
    background-color: #f7efd0;
    border-radius: 1rem;
    color: black;
    width: 55%;
    margin: auto;
  }
  input{
    padding: 0rem 1rem;
    flex: 1;
    border-radius: 1rem;
    width: 100%;
  }
  .login-policy{
    color: #878787;
    font-size:10px
  }
  input:focus{
    border-radius: 1rem;
    outline: none;
  }

  .loginform-label{
    flex: 0 0 40px;
    align-self: center;
  }
  .loginform-field{
    flex: 1;
  }
  @media screen and (max-width: 790px) {
    .login-leftBox{
      display: none;
    }
    .login-rightBox{
      flex: auto;
    }
  }
</style>
<script>
export default {
  data () {
    return {
      error: ''
    }
  },
  methods: {
    login: async function (e) {
      e !== null && e.preventDefault()
      let fd = new FormData(document.getElementById('loginForm'))
      // fd.append('login_id', 'teacher1@testing.com')
      // fd.append('password', 'demo')
      this.$store.dispatch('login', fd).then(user => {
        this.$router.push('/')
      }).catch(err => {
        //  handle error message
        console.error(err.message)
        this.error = '錯誤：' + err.message
      })
    },
    forget_password: function () {
      this.$router.push('/login/forget-password')
    }
  }
}
</script>
